module.exports = __webpack_public_path__ + "static/media/04 Generali OZE OWU.dcc5e690.pdf";